module.exports = " <resource-geofences class=\"layout-row flex\"></resource-geofences> ";